<template>
  <div class="wrapper">
    <div class="listWrap">
      <div class="item" style="border-bottom:1px solid #eee">
        <span class="left">权益卡号</span>
        <span class="right">{{aItem.card_number}}</span>
      </div>
      <div class="item">
        <span class="left">激活密码</span>
        <span class="right">{{aItem.password}}</span>
      </div>
    </div>
    <img class="card" @click="toDetail" src="../../assets/images/equity/equityCard.png" alt />
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      aItem: {}
    };
  },
  watch: {},
  methods: {
    toDetail(){
      this.$router.push({path:'/equityDetail',query:{type:'show'}});
      
    },
    initPage(){
      let option = {
          title: '有米@'+this.userInfo.name + "的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
       this.$commonPost({
        jydm: "flow_10104",
        flow_10104: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(resp => {
          this.aItem = resp;
        })
        .catch(err => {
          //this.$router.push({ path: "/information" });
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    }
  },
  created() {
    document.title = "权益卡";
    this.initPage()
  },
  mounted() {
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.listWrap {
  margin-top: .2rem;
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding-left: .24rem;
}
.item{
  width: 100%;
  box-sizing: border-box;
  padding-right: .24rem;
  height: .96rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .left{
    font-size: .34rem;
    color: #333;
  }
  .right{
    font-size: .3rem;
    color: #999;
  }
}
.card {
  width: 7.06rem;
  height: 3.36rem;
  margin-top: 0.22rem;
  margin-left: 0.22rem;
}
</style>



// WEBPACK FOOTER //
// src/components/equity/myEquity.vue